// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-algorithm-js": () => import("./../src/pages/algorithm.js" /* webpackChunkName: "component---src-pages-algorithm-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-modern-env-dev-js": () => import("./../src/pages/modernEnvDev.js" /* webpackChunkName: "component---src-pages-modern-env-dev-js" */),
  "component---src-pages-privacy-js": () => import("./../src/pages/privacy.js" /* webpackChunkName: "component---src-pages-privacy-js" */),
  "component---src-pages-tos-js": () => import("./../src/pages/tos.js" /* webpackChunkName: "component---src-pages-tos-js" */)
}

